import React from 'react';
import firebase from 'firebase';
import { Navigate } from 'react-router-dom';
import { useAtom } from 'jotai';
import { useDocumentData } from 'react-firebase-hooks/firestore';
import { firestoreKeys } from '../../shared/utils/constants';
import { userRecordAtom } from '../../shared/state/atoms';

export default function VerifiedApprovedGuard({ children }) {
  const [user] = useAtom(userRecordAtom);
  const supplierRef = React.useMemo(() => (user?.id ? firebase.firestore().collection(firestoreKeys.SUPPLIERS).doc(user.id) : null), [user?.id]);
  const [supplier, loadingSupplier] = useDocumentData(supplierRef, { idField: 'id' });
  const [verified, setVerified] = React.useState(false);
  const [checked, setChecked] = React.useState(false);

  React.useEffect(() => {
    const unsub = firebase.auth().onAuthStateChanged(async (u) => {
      if (!u) { setVerified(false); setChecked(true); return; }
      try { await u.reload(); } catch (e) { /* ignore */ }
      setVerified(!!u.emailVerified);
      setChecked(true);
    });
    return () => unsub();
  }, []);

  const approved = !!supplier?.approved || supplier?.status === 'Approved';
  const canProceed = verified && approved;

  // Wait for both auth verification check and supplier doc load
  if (!checked || loadingSupplier) return null;
  if (!canProceed) return <Navigate to="/" replace />;
  return <>{children}</>;
}
